var map = {
	"./1/list-pattern1.svg": 852,
	"./1/list-pattern2.svg": 853,
	"./1/list-pattern3.svg": 854,
	"./1/pattern1.svg": 855,
	"./1/pattern2.svg": 856,
	"./1/pattern3.svg": 857,
	"./10/list-pattern1.svg": 858,
	"./10/list-pattern2.svg": 859,
	"./10/list-pattern3.svg": 860,
	"./10/pattern1.svg": 861,
	"./10/pattern2.svg": 862,
	"./10/pattern3.svg": 863,
	"./11/list-pattern1.svg": 864,
	"./11/list-pattern2.svg": 865,
	"./11/list-pattern3.svg": 866,
	"./11/pattern1.svg": 867,
	"./11/pattern2.svg": 868,
	"./11/pattern3.svg": 869,
	"./2/list-pattern1.svg": 870,
	"./2/list-pattern2.svg": 871,
	"./2/list-pattern3.svg": 872,
	"./2/pattern1.svg": 873,
	"./2/pattern2.svg": 874,
	"./2/pattern3.svg": 875,
	"./3/list-pattern1.svg": 876,
	"./3/list-pattern2.svg": 877,
	"./3/list-pattern3.svg": 878,
	"./3/pattern1.svg": 879,
	"./3/pattern2.svg": 880,
	"./3/pattern3.svg": 881,
	"./4/list-pattern1.svg": 882,
	"./4/list-pattern2.svg": 883,
	"./4/list-pattern3.svg": 884,
	"./4/pattern1.svg": 885,
	"./4/pattern2.svg": 886,
	"./4/pattern3.svg": 887,
	"./5/list-pattern1.svg": 888,
	"./5/list-pattern2.svg": 889,
	"./5/list-pattern3.svg": 890,
	"./5/pattern1.svg": 891,
	"./5/pattern2.svg": 892,
	"./5/pattern3.svg": 893,
	"./6/list-pattern1.svg": 894,
	"./6/list-pattern2.svg": 895,
	"./6/list-pattern3.svg": 896,
	"./6/pattern1.svg": 897,
	"./6/pattern2.svg": 898,
	"./6/pattern3.svg": 899,
	"./7/list-pattern1.svg": 900,
	"./7/list-pattern2.svg": 901,
	"./7/list-pattern3.svg": 902,
	"./7/pattern1.svg": 903,
	"./7/pattern2.svg": 904,
	"./7/pattern3.svg": 905,
	"./8/list-pattern1.svg": 906,
	"./8/list-pattern2.svg": 907,
	"./8/list-pattern3.svg": 908,
	"./8/pattern1.svg": 909,
	"./8/pattern2.svg": 910,
	"./8/pattern3.svg": 911,
	"./9/list-pattern1.svg": 912,
	"./9/list-pattern2.svg": 913,
	"./9/list-pattern3.svg": 914,
	"./9/pattern1.svg": 915,
	"./9/pattern2.svg": 916,
	"./9/pattern3.svg": 917,
	"./99/list-pattern1.svg": 918,
	"./99/pattern1.svg": 919
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 959;